export default (name = '') => name.replace(/\.[^.$]+$/, '');
